
import axios from 'axios';
import { LLMSTSBResponse } from '../../types/llm';

export const getSTSBResults = async (
  sentence1: string,
  sentence2: string
) => {
  return await axios
    .post<LLMSTSBResponse>(
      `${process.env.REACT_APP_BACKEND_URL}/llm/stsb`,
      {
        sentence1: sentence1,
        sentence2: sentence2,
      }
    )
    .then((response) => {
      return response.data;
    });
};
